import React from 'react';
import Dashboard from './Dashboard';

export default function RealDashboardPage() {
  return <Dashboard scope="REAL" />;
}
